import React from "react";
import { connect } from "react-redux";
import ReactEcharts from "echarts-for-react";
import { averageBarChartOption } from "../../Data/Charts";
import "echarts-gl";
class AverageBarChart extends React.Component {
  componentDidMount() {

  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.averageChartData !== this.props.averageChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const { averageChartData } = this.props;
    if (averageChartData.length === 0) return [];

    const labels = averageChartData.map(item => item.name);
    const data = averageChartData.map(item => ({
      name: item.name,
      days: item.days,
      hours: item.hours,
      minutes: item.minutes,
      total_minutes: item.total_minutes
    }));
    return {
      labels,
      data
    };
  };
  render() {

    const { labels, data } = this.chartPlace();

    const option = averageBarChartOption(labels, data);

    return (
        <ReactEcharts
            option={option}
            opts={{ renderer: 'svg' }}
            style={{ height: '300px', width: '100%' }}
        />

    );
  }
}

const mapStateToProps = (state) => ({
  averageChartData: state.analyticalReducer.averageChartData,
});

export default connect(mapStateToProps, {})(AverageBarChart);
